export const TRANSLATIONS_EN_10203058 = {
	enquire: "Inquire",
};
